import type { AgentTone, AIAgent } from '../services/agents-api';

export function toneLabel(tone: AgentTone) {
  if (tone === 'PROFESSIONAL') return 'Formal';
  if (tone === 'FRIENDLY') return 'Friendly';
  return 'Concise';
}

export function channelsLabel(count: number) {
  return count === 1 ? '1 Channel' : `${count} Channels`;
}

export function agentChannels(agent: AIAgent) {
  return agent.channels ?? [];
}

export function agentKbases(agent: AIAgent) {
  return agent.kbases ?? [];
}

export function needsKnowledgeBase(agent: AIAgent) {
  return agentKbases(agent).length === 0;
}

export function isAgentConnected(agent: AIAgent) {
  return agentChannels(agent).length > 0;
}

/** The backend's switch. Separate from being connected: a brand-new agent is
 * active and simply has no channel yet. */
export function isAgentActive(agent: AIAgent) {
  return agent.is_active !== false;
}

/** The connected agent with the most channels — Figma's "Primary" badge. */
export function primaryAgentId(agents: AIAgent[]) {
  const connected = agents.filter(isAgentConnected);
  if (connected.length === 0) return null;
  return connected.reduce((best, agent) =>
    agentChannels(agent).length > agentChannels(best).length ? agent : best
  ).id;
}

export function agentSetupSteps(agents: AIAgent[]) {
  return {
    built: agents.length > 0,
    hasKnowledgeBase: agents.some((row) => agentKbases(row).length > 0),
    hasChannel: agents.some(isAgentConnected),
  };
}

export function isAgentSetupComplete(agents: AIAgent[]) {
  const steps = agentSetupSteps(agents);
  return steps.built && steps.hasKnowledgeBase && steps.hasChannel;
}
